<template>
    <v-dialog
            :value="!!value"
            :retain-focus="false"
            persistent
            max-width="800"
    >
        <v-form
                v-model="validForm"
                ref="form"
                @submit.prevent="submit"
        >
            <v-card
                    :loading="loading > 0"
                    :disabled="loading > 0"
            >
                <v-card-title class="grs-card-title px-0">
                   <span>ثبت فیش پرداختی</span>

                    <v-spacer></v-spacer>

                    <v-btn
                            text
                            small
                            icon
                            @click="$emit('close')"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pb-0">
                    <v-text-field
                            class="ltr"
                            v-model="value.amount"
                            :value="value.amount ? $n(value.amount) : null"
                            @input="value.amount = parseInt($event)"
                            :hint="priceToTomanPhrase(value.amount)"
                            :label="$t('amount')"
                            :rules="[rules.required]"
                    ></v-text-field>
                    <v-text-field
                            v-model="paidAtLabel"
                            label="تاریخ پرداخت"
                            id="paid_at"
                            readonly
                            clearable
                    ></v-text-field>
                    <date-picker
                            v-model="value.paid_at"
                            clearable
                            format="X"
                            type="datetime"
                            display-format="jMMMM jD"
                            element="paid_at"
                            simple
                    />
                    <UploadArea
                            v-model="document"
                            :rules="[rules.required,rules.maxUploadSize]"
                            accept="application/pdf"
                    >
                        <template v-slot:label>
                            <h2 class="text-center h2">بارگزاری سند واریز</h2>
                            <div class="text-center subtitle-2 mt-2">حداکثر سایز مجاز 5MB.</div>
                        </template>
                    </UploadArea>
                </v-card-text>

                <v-card-actions class="px-4 pb-4">
                    <v-spacer></v-spacer>

                    <v-btn
                            color="secondary"
                            text
                            class="px-4"
                            @click="$emit('close')"
                    >{{$t('cancel')}}</v-btn>

                    <v-btn
                            color="primary"
                            class="px-4"
                            type="submit"
                    >
                        {{$t('send_request')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
    import { acceptableDocumentFormat,maxUploadSize, required, to} from '@/scripts/validationRules';
    import UploadArea from '../components/UploadArea';
    import Service from "../services/AccountingReceiptsService";
    import StorageService from "../services/StorageService";
    import { priceToTomanPhrase } from '@/scripts/PriceUtils';

    export default {
        props: {
            item : {
                required: true
            }
        },
        components : {
            UploadArea
        },
        computed: {
            paidAtLabel(){
                if(!this.value.paid_at) return null;
                console.log(this.value.paid_at);
                return this.getJalaliDate(this.value.paid_at * 1000, 'H:m:s jD jMMMM jYYYY');
            },
        },
        data() {
            return {
                validForm: false,
                fileLoading : false,
                document : null,
                loading: 0,
                showPass : false,
                value : {...this.item},
                rules: {
                    acceptableDocumentFormat,
                    maxUploadSize,
                    required,
                    to
                },

            }
        },
        methods: {
            priceToTomanPhrase,
            async submit() {
                if(!this.document){
                    return this.$notify({
                        group: 'formGroup',
                        type: 'error',
                        title: 'بارگزاری سند واریز ضروری می باشد.',
                    });
                }
                if(!this.validForm) {
                    return this.$refs.form.validate();
                }

                try {
                    this.loading++;
                    this.fileLoading = true;

                    let formData = new FormData();

                    formData.append('document', this.document);
                    formData.append('caption', this.value.caption);

                    let documentResponse = await StorageService.uploadAccountingReceipt(formData);

                    this.fileLoading = false;

                    this.value.file_id = documentResponse.data.value.file.id;

                    let {
                        data
                    } = await Service.create(this.value);
                    this.$emit('submit', data);

                    this.$notify({
                        group: 'formGroup',
                        type: 'success',
                        title: data.message,
                    });

                } finally {
                    this.loading--;
                }

                this.$emit('close');
            }
        }
    }
</script>